import { render, staticRenderFns } from "./InformacoesRestricao.vue?vue&type=template&id=520eae6d&scoped=true"
import script from "./InformacoesRestricao.vue?vue&type=script&lang=js"
export * from "./InformacoesRestricao.vue?vue&type=script&lang=js"
import style0 from "./InformacoesRestricao.vue?vue&type=style&index=0&id=520eae6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520eae6d",
  null
  
)

export default component.exports